import React from 'react';
import ReactDOM from 'react-dom';
import {AddFavouritesApp} from "./apps/AddFavouritesApp";
import {ShareItineraryApp} from "./apps/ShareItineraryApp";
import initializeReadMoreApp from './apps/ReadMoreApp';
import {GeneratePdfItineraryApp} from "./apps/GeneratePdfItineraryApp";
import {ExcursionInspirationApp} from "./apps/ExcursionInspirationApp";
import LabelPopup from "./components/Favourites/LabelPopup";
import {ItineraryRecommendationApp} from "./apps/ItineraryRecommendationApp";

let addLabelPopupRoot = document.getElementsByClassName('addLabelPopupRoot');
let addFavouritesRoots = document.getElementsByClassName('addFavouritesRoot');
let shareItineraryRoots = document.getElementsByClassName('shareItineraryRoot');
let generatePdfItineraryRoot = document.getElementsByClassName('generatePdfItineraryRoot');
let readMoreRemoveOverflowButtons = document.getElementsByClassName('readMoreRemoveOverflow');
let excursionInspirationRoots = document.getElementsByClassName('excursionInspirationRoot');
let itineraryRecommendationsRoots = document.getElementsByClassName('itineraryRecommendation');

[].forEach.call(addLabelPopupRoot, function(addLabelPopupRoot){
    const popupLabel = JSON.parse(addLabelPopupRoot.getAttribute('data-page-popup-label'));

    ReactDOM.render(
        <LabelPopup labels={popupLabel} />,
        addLabelPopupRoot
    );
});

[].forEach.call(addFavouritesRoots, function(addFavouritesRoot){
    const itineraryUid = parseInt(addFavouritesRoot.getAttribute('data-itinerary'),10);
    const favouriteType = addFavouritesRoot.getAttribute('data-favourite-type');
    const favouriteLink = addFavouritesRoot.getAttribute('data-page-favourites');

    ReactDOM.render(
		<AddFavouritesApp itineraryUid={itineraryUid} favouriteType={favouriteType} favouriteLink={favouriteLink}/>,
        addFavouritesRoot
    );
});

[].forEach.call(shareItineraryRoots, function(shareItineraryRoot){
    const itineraryUid = parseInt(shareItineraryRoot.getAttribute('data-itinerary'),10);
    const reCaptchaSiteKey = shareItineraryRoot.getAttribute('data-sitekey');
    const excursionUid = 0;

    ReactDOM.render(
        <ShareItineraryApp itineraryUid={itineraryUid} excursionUid={excursionUid} reCaptchaSiteKey={reCaptchaSiteKey} />,
        shareItineraryRoot
    );
});

[].forEach.call(generatePdfItineraryRoot, function(shareItineraryRoot){
    const itineraryUid = parseInt(shareItineraryRoot.getAttribute('data-itinerary'),10);
    const fileName = shareItineraryRoot.getAttribute('data-filename');
    const downloadLink = document.getElementById('generatePdfUrl')===null?null:document.getElementById('generatePdfUrl').innerHTML.trim();
    const downloadLinkTextOnly = document.getElementById('generatePdfUrlTextOnly')===null?null:document.getElementById('generatePdfUrlTextOnly').innerHTML.trim();
    const downloadLinkAgency = document.getElementById('generatePdfUrlAgency')===null?null:document.getElementById('generatePdfUrlAgency').innerHTML.trim();

    ReactDOM.render(
            <GeneratePdfItineraryApp itineraryUid={itineraryUid} downloadLink={downloadLink} downloadLinkTextOnly={downloadLinkTextOnly} downloadLinkAgency={downloadLinkAgency} fileName={fileName} />,
            shareItineraryRoot
    );
});

[].forEach.call(readMoreRemoveOverflowButtons, function(readMoreRemoveOverflowButton){
    initializeReadMoreApp(readMoreRemoveOverflowButton);
});

[].forEach.call(excursionInspirationRoots, function(excursionInspirationRoot) {
    const filter= JSON.parse(excursionInspirationRoot.getAttribute('data-filter'));
    const excursionType = excursionInspirationRoot.getAttribute('data-nezzo-excursion-type');

    ReactDOM.render(
        <ExcursionInspirationApp filter={filter} excursionType={excursionType} />,
        excursionInspirationRoot
    );
});
[].forEach.call(itineraryRecommendationsRoots, function(itineraryRecommendationsRoot) {
    const filter= JSON.parse(itineraryRecommendationsRoot.getAttribute('data-filter'));
    const itineraryType = itineraryRecommendationsRoot.getAttribute('data-page-favourites');

    ReactDOM.render(
        <ItineraryRecommendationApp filter={filter} favouriteLink={itineraryType} />,
        itineraryRecommendationsRoot
    );
});



// WEBPACK FOOTER //
// ./src/itineraryDetail.js